import fetch from 'isomorphic-fetch';
import Config from '../../config/';

const API = {
  data: {
    async getAll(obj) {
      const response = await fetch(
        `${Config.api}/api/detailfatigue/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      const data = await response.json();

      return {
        data: data.response,
        status
      };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/detail_fatigue/api/index.js